import React from "react";

import "../asset/stlyes/footer.css";

class Footer extends React.Component {
  state = {
    year: "",
  };

  getTime = () => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    return this.setState({
      year: currentYear,
    });
  };

  handleLanguageClick = (lang) => {
    // Update language preference in local storage
    localStorage.setItem("language", lang);
    // Update state to re-render component
    window.location.reload();
  };

  componentDidMount() {
    this.getTime();
  }

  render() {
    return (
      <div className="footer">
        <hr />
        <div className="container">
          <div className="row">
            <div className="col-md-3 respont-logo text-grey">
              <b className="font-PoppinsBold mx-1">@WizzFun</b>
            </div>
            <div className="col-md-9 contact">
              <a
                href="https://www.linkedin.com/in/azfarwisnu"
                target="_blank"
                rel="noreferrer"
              >
                <i className="bi bi-linkedin"></i>
              </a>
              <a
                href="https://github.com/azfarwisnu"
                target="_blank"
                rel="noreferrer"
              >
                <i className="bi bi-github"></i>
              </a>
              <a
                href="mailto:azfarwisnu@gmail.com"
                target="_blank"
                rel="noreferrer"
              >
                <i className="bi bi-envelope-fill"></i>
              </a>
            </div>
          </div>
          <p className="copyright">
            &copy; wisnuazfarm {this.state.year} made with{" "}
            <i className="bi bi-balloon-heart"></i>. All rights reserved.
            <br />
            <i className="bi"></i>Thanks{" "}
            <a href="https://dribbble.com/thierryfousse" className="font-green">
              @thierryfousse
            </a>{" "}
            Assets
          </p>
        </div>
      </div>
    );
  }
}

export default Footer;
